import request, { type ApiResponse } from '@/utils/request'

export interface NspParams {
  doorType: string
  yearFront: string
  yearEnd: string
  year: number
  account: string[]
  type?: string
}

/** nspBy168Tag 接口请求参数（无 type） */
export type NspBy168TagParams = Omit<NspParams, 'type'>

/** nspBy168Tag 树形节点 */
export interface NspBy168TagItem {
  name: string
  n6n9k3k9: number
  initialBkp: number
  actualBkp: number
  n101K10: number
  n102n104: number
  dnc: number
  opened: number
  aop: number | null
  n6n9k3k9Rate: number | null
  n101K10Rate: number | null
  n102n104Rate: number | null
  dncRate: number | null
  openedRate: number | null
  timeProgress: number | null
  children: NspBy168TagItem[] | null
}

// removed Q1-Q4 only check to support caching for arbitrary ranges

const buildCacheKey = (name: string, data: NspParams) => {
  const acc = Array.isArray(data.account) ? data.account.join(',') : ''
  const typ = data.type ? `|${data.type}` : ''
  return `dashboard-cache:${name}|${data.year}|${data.doorType}|${data.yearFront}|${data.yearEnd}|${acc}${typ}`
}

export const getTotal = (data: NspParams): Promise<ApiResponse<any>> => {
  const key = buildCacheKey('total', data)
  try {
    const cached = sessionStorage.getItem(key)
    if (cached) return Promise.resolve(JSON.parse(cached))
  } catch { }
  return request
    .post('/app/door/dashboard/new/nspInProgress/total', data)
    .then((res) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(res))
      } catch { }
      return res
    })
}

export const getNspInProgressFourParts = (
  data: NspParams,
): Promise<ApiResponse<any>> => {
  const key = buildCacheKey('fourParts', data)
  try {
    const cached = sessionStorage.getItem(key)
    if (cached) return Promise.resolve(JSON.parse(cached))
  } catch { }
  return request
    .post('/app/door/dashboard/new/nspInProgress/fourParts', data)
    .then((res) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(res))
      } catch { }
      return res
    })
}

export const getNspInProgressFullGate = (
  data: NspParams,
): Promise<ApiResponse<any>> => {
  const key = buildCacheKey('fullGate', data)
  try {
    const cached = sessionStorage.getItem(key)
    if (cached) return Promise.resolve(JSON.parse(cached))
  } catch { }
  return request
    .post('/app/door/dashboard/new/nspInProgress/fullGate', data)
    .then((res) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(res))
      } catch { }
      return res
    })
}

export const getNspInProgressNspBy168Tag = (
  data: NspBy168TagParams,
): Promise<ApiResponse<NspBy168TagItem[]>> => {
  const key = buildCacheKey('nspBy168Tag', data)
  try {
    const cached = sessionStorage.getItem(key)
    if (cached) return Promise.resolve(JSON.parse(cached))
  } catch { }
  return request
    .post('/app/door/dashboard/new/nspInProgress/nspBy168Tag', data)
    .then((res) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(res))
      } catch { }
      return res
    })
}
